<template>
  <v-container>
    <div class="text-xs-right">
      <v-btn outline color="primary" @click="onAdd" :loading="loading">
        <v-icon>add</v-icon>Add campaign
      </v-btn>
    </div>

    <pagination
      v-model="items"
      :total="total"
      :loading="loading"
      :size="size"
      @onChangePage="onChangePage"
    >
      <!-- item, index, size, total, pageNumber -->
      <template v-slot="{ item }">
        <v-card
          class="mb-3"
          :style="[
            item.campaign_active
              ? { 'border-left': ' 5px solid #a0e83d' }
              : { 'border-left': ' 5px solid #ff0100' }
          ]"
        >
          <v-card-text>
            <v-layout>
              <v-flex>
                <div class="primary--text font-weight-bold">
                  {{ item.name || '-' }}
                </div>
                <v-layout>
                  <v-flex shrink>
                    <template v-if="item.start_date">
                      <span class="font-weight-bold"> Start date: </span>
                      <v-chip small color="info" class="white--text mr-3" disabled>
                        {{ item.start_date | DateFormat('DD/MM/YYYY') }}
                      </v-chip>
                    </template>
                  </v-flex>
                  <v-flex>
                    <template v-if="item.end_date">
                      <span class="font-weight-bold"> End date: </span>
                      <v-chip small color="info" class="white--text" disabled>
                        {{ item.end_date | DateFormat('DD/MM/YYYY') }}
                      </v-chip>
                    </template>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex shrink class="text-xs-right">
                <v-btn small fab outline @click="onEdit(item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn small fab outline @click="onDelete(item)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>

            <span class="font-weight-bold">Trigger After: </span>{{ item.trigger_after || '-' }}

            <div class="pa-2 my-2" style="border-radius: 15px; background: #eee">
              {{ item.messages || '-' }}
            </div>

            <v-layout wrap>
              <v-flex xs12 sm6>
                <!-- <span class="font-weight-bold">Limit: </span>{{ item.limit || 'Unlimit' }} Customers -->
                <span class="font-weight-bold">Limit By User : </span>
                {{ item.limit_by_user }} {{ item.limit }} สิทธิ์ / {{ item.limit_period }}
                {{ item.period_type }}
              </v-flex>
              <v-flex xs12 sm6>
                <span class="font-weight-bold">Upload code:</span>
                {{ item.codes ? item.codes.length : 0 }}
              </v-flex>
            </v-layout>

            <template v-if="item.is_followup_schedule">
              <FollowupMessageScheduleDetail :value="item" />
            </template>
          </v-card-text>
        </v-card>
      </template>
    </pagination>

    <template v-if="showAdd">
      <followup-message-manage
        v-model="showAdd"
        @onChange="onUpdated"
        @onSaveCampaign="onRefresh"
      ></followup-message-manage>
    </template>
    <template v-if="showEdit">
      <followup-message-manage
        v-model="showEdit"
        :item="currentItem"
        @onChange="onUpdated"
        @onSaveCampaign="onRefresh"
      ></followup-message-manage>
    </template>
  </v-container>
</template>

<script>
import Pagination from '@/components/elements/Pagination3.vue'
import FollowupMessageManage from './FollowupMessageManage'
import { mapGetters } from 'vuex'
import api from '@/api'
import FollowupMessageScheduleDetail from './FollowupMessageScheduleDetail'
export default {
  data() {
    return {
      showAdd: false,
      showEdit: false,
      size: 10,
      items: [],
      currentItem: null,
      loading: true,
      total: 0,
      pageNumber: 1
    }
  },
  components: {
    Pagination,
    FollowupMessageManage,
    FollowupMessageScheduleDetail
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  async mounted() {
    await this.onChangePage(1)
    await this.$store.dispatch('loadIntent')
  },
  methods: {
    async getFollowupMessage(pageNumber) {
      this.pageNumber = pageNumber

      let request = {
        pageid: this.selectedBot.pageid,
        params: {
          limit: this.size,
          offset: (pageNumber - 1) * this.size
          // sortby: '',
          // isdesc: '',
          // search: ''
        }
      }
      let response = await api.getFollowupMessage(request)

      if (response.status == true) return { items: response.result, total: response.total }
      else return []
    },
    onAdd() {
      this.showAdd = true
    },
    onEdit(item) {
      this.currentItem = item
      this.showEdit = true
    },
    async onDelete(item) {
      let result = await this.$swal.fire({
        title: this.$t('Do you want to delete this?'),
        type: 'warning',
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true,
        showCancelButton: true
      })
      if (result.value) {
        let index = this.items.findIndex((el) => el.id == item.id)
        if (index != -1) {
          this.loading = true

          let response = await api.deleteFollowupMessage({
            pageid: this.selectedBot.pageid,
            id: item.id
          })

          if (response && response.status) {
            await this.onChangePage(this.pageNumber)

            await this.$swal.fire({
              title: this.$t('Success'),
              type: 'success',
              confirmButtonText: this.$t('Confirm'),
              reverseButtons: true
            })
          }
          this.loading = false
        }
      }
    },
    async onUpdated(item) {
      if (item) {
        let index = this.items.findIndex((el) => el.id == item.id)
        if (index != -1) this.$set(this.items, index, item)
        else await this.onChangePage(this.pageNumber)
        await this.$swal.fire({
          title: this.$t('Success'),
          type: 'success',
          confirmButtonText: this.$t('Confirm'),
          reverseButtons: true
        })
      }
      this.currentItem = null
    },
    async onChangePage(pageNumber) {
      this.loading = true
      let response = await this.getFollowupMessage(pageNumber)
      if (response) {
        let { items, total } = response
        this.total = total
        this.items = items
      } else {
        this.total = 0
        this.items = []
      }

      this.loading = false
    },
    onRefresh() {
      this.onChangePage(this.pageNumber)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/FollowupMessage.vue